module.exports = __webpack_public_path__ + "media/type4(epic).aeda9fe6.mp4";